// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flavorfinder__question-container{display:block;background-color:#fff;border-radius:8px;padding-inline:10px}@media(min-width: 960px){.flavorfinder__question-container{padding-inline:0}}.flavorfinder__question-wrapper{display:flex;flex-wrap:wrap}.flavorfinder__question-footer{padding-top:.625rem;display:flex;justify-content:center}@media(min-width: 960px){.page--dark .flavorfinder__question-container{padding-inline:10px}}", ""]);
// Exports
module.exports = exports;
